// The connectivity heartbeat's refetch decision (pagination audit 2026-10-01).
//
// The heartbeat polls the cheap event-log head (`GET /v1/head`), not the
// full `/v1/state` (LIX + grounding over every material). State is refetched
// only when the head moved since the last tick, so an idle tab costs the
// server one count per tick and a change made elsewhere (another tab, an
// agent turn, another device) still reaches this tab within one tick.

export type { LogHead };
export { shouldRefetchState };

// The workspace event log's head position, as served by `/v1/head`.
type LogHead = number;

// No previous observation (first tick after mount / reconnect / sign-in)
// counts as changed: something may have moved while this tab wasn't looking.
const shouldRefetchState = (
    previous: LogHead | undefined,
    current: LogHead,
): boolean => previous !== current;
